export const fetchCustomer = (state = {}) => state;
